import { render, staticRenderFns } from "./txtTerms.vue?vue&type=template&id=2d816976&scoped=true"
import script from "./txtTerms.vue?vue&type=script&lang=js"
export * from "./txtTerms.vue?vue&type=script&lang=js"
import style0 from "./txtTerms.vue?vue&type=style&index=0&id=2d816976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d816976",
  null
  
)

export default component.exports